const getQuoteFee = (quote, fromAsset) => {
    return quote.exchangeFeeData.feeOpts?.fee || fromAsset.feeAsset.currency.ZERO;
};
export default getQuoteFee;
